import { getAppToken, getConfigInterceptors } from '@shared/utils'
import axios from 'axios'

import { OpenAPI } from './requests'

OpenAPI.BASE = import.meta.env.VITE_APP_INSURANCE_API

export const $insuranceAxios = axios.create({
  baseURL: import.meta.env.VITE_APP_INSURANCE_API,

  headers: {
    'Content-Type': 'application/json'
  }
})

const saasAppToken = ()=>getAppToken('insurance')

getConfigInterceptors($insuranceAxios, undefined, saasAppToken)
